import TypeError from '.TypeError';

import * as TOKEN from './TOKEN';
import Layer, { protect } from './Layer';

export default class Url extends Layer       {
	
	         nameLiteral               ;
	valueLiteral         = '';
	
	constructor (nameLiteral               ) {
		super();
		TOKEN.currentLayer && ( TOKEN.collection_url[TOKEN.collection_url.length] = this );
		this.nameLiteral = nameLiteral;
		return this;
	}
	
	[TOKEN.consume] (         ) {
		switch ( TOKEN.type ) {
			case TOKEN.string:
				if ( this.valueLiteral ) { break; }
				this.valueLiteral = TOKEN.literal;
				return this;
			case ')':
				return this[TOKEN.parent];
			case TOKEN.whitespace:
			case TOKEN.comment:
				return this;
		}
		return null;
	}
	
	[Symbol.toPrimitive] (         ) { return this.nameLiteral ? `${this.nameLiteral}(${this.valueLiteral})` : this.valueLiteral; }
	
	* [Symbol.iterator] (         ) { throw TypeError(`beautify url`); }
	
	static default = protect(this);
	
};

export const newUrl =                        (parent   , key          = 'newItem')    => {
	const index = TOKEN.literal.indexOf('(');
	const url = parent[key             ] = new Url(TOKEN.literal.slice(0, index));
	url.valueLiteral = TOKEN.literal.slice(index + 1, -1).replace(TOKEN._ws_, '');
	return parent;
};
